var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column"},[_c('div',{staticClass:"bullet row"},[_c('div',{staticClass:"item active"},[_vm._v(_vm._s(_vm.n || '0'))]),_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm.total || '0'))])]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }